export const objSettings = {
  isSc: false,
  isJag: false,
};
